/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Table_Updated_AtInputs */

const es_settings_files_table_updated_at = /** @type {(inputs: Settings_Files_Table_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado`)
};

const en_settings_files_table_updated_at = /** @type {(inputs: Settings_Files_Table_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated At`)
};

/**
* | output |
* | --- |
* | "Updated At" |
*
* @param {Settings_Files_Table_Updated_AtInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_table_updated_at = /** @type {((inputs?: Settings_Files_Table_Updated_AtInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Table_Updated_AtInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_table_updated_at(inputs)
	return en_settings_files_table_updated_at(inputs)
});
export { settings_files_table_updated_at as "settings.files.table.updated_at" }